module.exports = __webpack_public_path__ + "static/img/cont35 (7).4ef7603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (7).jpg
// module id = sjMd
// module chunks = 0